import {DELETE_ENROLLMENT} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case DELETE_ENROLLMENT:
            return action.payload;
        default:
            return state;
    }
};